import type { IVocalise } from './vocalise';
import { vocaliseSchema } from './vocalise';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const START = 'VOCALISE/START';

export interface IStartAction {
  type: typeof START;
  payload: IVocalise;
}

export const startActionSchema = objectSchemaOf<IStartAction>({
  type: Joi.string().required().valid(START),
  payload: vocaliseSchema.required(),
});

export const start = actionCreator({
  type: START,
  schema: startActionSchema,
});
